// extracted by mini-css-extract-plugin
module.exports = {"recentCompensationContainer":"_27OICji8","containerTitle":"_2yAvPI7v","label":"pSzoltsl","formRow":"_3YeLCeL3","oteInputContainer":"_10ZkWK53"};
    if(module.hot) {
      // 1754514958177
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  